import { render, staticRenderFns } from "./AllMarkings.vue?vue&type=template&id=9061d054&scoped=true"
import script from "./AllMarkings.vue?vue&type=script&lang=js"
export * from "./AllMarkings.vue?vue&type=script&lang=js"
import style0 from "./AllMarkings.vue?vue&type=style&index=0&id=9061d054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9061d054",
  null
  
)

export default component.exports